export default {
  ourTotality: [
    {
      title: 'Our mission',
      text: '<p>Our mission is to make learning accessible and affordable for everyone, which is why we offer personalized one-on-one tutoring and hybrid options to create a truly unique learning experience.</p>',
      image: require('@images/public/about-us/vision.png')
    },
    {
      title: 'Our beliefs',
      text: '<p>Where we believe private tutoring is the most effective way to learn. Our team specializes in a wide range of subjects and languages, with a focusing on English. We\'re committed to making private' +
          ' tutoring affordable for everyone, which is why we\'ve developed innovative methods like hybrid tutoring to increase efficiency and reduce costs. Join us today and start achieving your academic goals with personalized support from our experienced tutors. </p>',
      image: require('@images/public/about-us/beliefs.png')
    },
    {
      title: 'Our goals',
      text: '<p>At Ostado, we\'re dedicated to two main goals: connecting students with the best tutors and creating a stable income for our tutors. We understand that finding a great tutor can be challenging, which is why we\'ve made it our mission to match you with highly qualified tutors who are passionate about teaching. Additionally, by filling our tutors\' schedules, we ensure they have a reliable income and can focus on delivering top-quality lessons. Join us today and experience the benefits of personalized tutoring from exceptional educators.</p>',
      image: require('@images/public/about-us/goals.png')
    }
  ],
  features: [
    {
      title: 'Efficient tutoring',
      icon: require('@images/public/about-us/features-1.png'),
      content: 'At Ostado, we strive to make the most of tutors\' time. We carefully consider the needs of future students and work to bring on new tutors who can provide high-quality instruction across a range of courses.'
    },
    {
      title: 'Tutor Accountability',
      icon: require('@images/public/about-us/features-2.png'),
      content: 'We monitor tutor performance closely and quickly replace those who work below our high standards. Our priority is providing exceptional education for our students.'
    },
    {
      title: 'Tutor selection',
      icon: require('@images/public/about-us/features-3.png'),
      content: 'We provide accurate and comprehensive information about our tutors to help you choose the best fit for your needs. Our goal is your success with the right tutor.'
    }
  ],
  founders: [
    {
      name: 'Mohammad Farahani',
      job_position: 'CEO, Co-founder',
      picture: require('@images/public/about-us/mohamad_farahani.jpg'),
      linkedin: 'https://www.linkedin.com/in/mdfarahani/'
    },
    {
      name: 'Vahid Ebrahimirad',
      job_position: 'CTO, Co-founder',
      picture: require('@images/public/about-us/vahid_ebrahimi.jpg'),
      linkedin: 'https://www.linkedin.com/in/ebrahimirad'
    }
  ]
}
